// extracted by mini-css-extract-plugin
export var card = "_ld-0";
export var content = "_ld-2";
export var details = "_ld-3";
export var icon = "_ld-1";
export var iconBlue = "_ld-5";
export var iconBrand = "_ld-4";
export var iconGrayBlue = "_ld-6";
export var iconGreen = "_ld-7";
export var iconIndigo = "_ld-8";
export var iconOrange = "_ld-9";
export var iconPurple = "_ld-a";
export var iconRed = "_ld-b";
export var iconWarning = "_ld-c";